import { render, staticRenderFns } from "./RevenueIndex.vue?vue&type=template&id=325dc864"
import script from "./RevenueIndex.vue?vue&type=script&lang=ts"
export * from "./RevenueIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports